import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function StudentRankingCard({ user }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, [user.id]);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/student/${user.id}/ranking`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching student stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
          <p className="mt-2 text-sm text-gray-600">Cargando estadísticas...</p>
        </div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  return (
    <div className="bg-gradient-to-br from-purple-600 to-blue-600 rounded-xl shadow-lg p-6 text-white">
      <div className="flex items-center gap-3 mb-6">
        <div className="text-4xl">📊</div>
        <div>
          <h2 className="text-2xl font-bold">Mis Estadísticas</h2>
          <p className="text-purple-100">Tu progreso y rendimiento</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {/* Total Activities */}
        <div className="bg-white bg-opacity-20 rounded-lg p-4 backdrop-blur-sm">
          <div className="text-3xl font-bold">{stats.statistics.total_activities}</div>
          <div className="text-sm text-purple-100 mt-1">Actividades</div>
        </div>

        {/* Average Score */}
        <div className="bg-white bg-opacity-20 rounded-lg p-4 backdrop-blur-sm">
          <div className="text-3xl font-bold">{stats.statistics.average_score.toFixed(1)}</div>
          <div className="text-sm text-purple-100 mt-1">Promedio</div>
        </div>

        {/* Total Points */}
        <div className="bg-white bg-opacity-20 rounded-lg p-4 backdrop-blur-sm">
          <div className="text-3xl font-bold">{stats.statistics.total_points}</div>
          <div className="text-sm text-purple-100 mt-1">Puntos Totales</div>
        </div>

        {/* Quizzes */}
        <div className="bg-white bg-opacity-20 rounded-lg p-4 backdrop-blur-sm">
          <div className="text-3xl font-bold">{stats.statistics.total_quizzes}</div>
          <div className="text-sm text-purple-100 mt-1">📝 Quizzes</div>
        </div>
      </div>

      {/* Detailed Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* TextHunt */}
        <div className="bg-white bg-opacity-10 rounded-lg p-4 backdrop-blur-sm border border-white border-opacity-20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-2xl">📚</span>
            <span className="text-2xl font-bold">{stats.statistics.total_texthunts}</span>
          </div>
          <div className="text-sm">TextHunt completados</div>
          <div className="text-xs text-purple-100 mt-1">
            {stats.scores.texthunt_total} puntos
          </div>
        </div>

        {/* Hangman */}
        <div className="bg-white bg-opacity-10 rounded-lg p-4 backdrop-blur-sm border border-white border-opacity-20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-2xl">🎯</span>
            <span className="text-2xl font-bold">{stats.statistics.total_hangman}</span>
          </div>
          <div className="text-sm">Ahorcados jugados</div>
          <div className="text-xs text-purple-100 mt-1">
            {stats.scores.hangman_total} puntos
          </div>
        </div>

        {/* Terminal Quest */}
        <div className="bg-white bg-opacity-10 rounded-lg p-4 backdrop-blur-sm border border-white border-opacity-20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-2xl">💻</span>
            <span className="text-2xl font-bold">{stats.statistics.completed_terminal_quests}/{stats.statistics.total_terminal_quests}</span>
          </div>
          <div className="text-sm">Terminal Quest</div>
          <div className="text-xs text-purple-100 mt-1">
            {stats.statistics.completed_terminal_quests} completados
          </div>
        </div>
      </div>

      {/* Encouragement Message */}
      <div className="mt-6 bg-white bg-opacity-10 rounded-lg p-4 backdrop-blur-sm border border-white border-opacity-20">
        <div className="flex items-center gap-2">
          <span className="text-2xl">
            {stats.statistics.total_activities === 0 ? '🎯' : stats.statistics.average_score >= 800 ? '🌟' : stats.statistics.average_score >= 600 ? '⭐' : '💪'}
          </span>
          <div className="text-sm">
            {stats.statistics.total_activities === 0 && '¡Comienza tu primera actividad para ver tu progreso!'}
            {stats.statistics.total_activities > 0 && stats.statistics.average_score >= 800 && '¡Excelente trabajo! Sigue así 🎉'}
            {stats.statistics.total_activities > 0 && stats.statistics.average_score >= 600 && stats.statistics.average_score < 800 && '¡Buen rendimiento! Sigue mejorando 👍'}
            {stats.statistics.total_activities > 0 && stats.statistics.average_score < 600 && '¡Sigue practicando! Cada intento te hace mejor 💪'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentRankingCard;
